import React from "react";
import { motion } from "framer-motion";
import { PlayCircle, Download } from "lucide-react";
import StoreButtons from "../common/StoreButtons";
import mockup from "../../assets/mockup.png";
import "./HeroSection.css";

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-bg-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
      </div>
      <div className="container hero-container">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <span className="hero-badge">Wellness Companion</span>
          <h1 className="hero-title">
            Find Your Calm.
            <br />
            <span className="text-primary">Anytime, Anywhere.</span>
          </h1>
          <p className="hero-subtitle">
            Relax is your personal wellness companion designed to reduce stress,
            improve sleep, and boost focus through soothing music and peaceful
            experiences.
          </p>
          <p className="hero-highlight">
            Start your journey to a calmer mind in just{" "}
            <strong>20 minutes a day.</strong>
          </p>
          <div className="hero-buttons">
            <button
              className="btn-secondary"
              style={{ marginLeft: "16px" }}
              onClick={() =>
                window.open(
                  "https://youtu.be/MN_JP4gyBNI?si=qcxgd9ndiCCke9SZ",
                  "_blank",
                )
              }
            >
              <PlayCircle size={20} /> Watch Demo
            </button>
          </div>
        </motion.div>

        <motion.div
          className="hero-image-wrapper"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <img
            src="./images/hero-section.png"
            alt="Relax App Mockup"
            className="hero-mockup"
          />

          <motion.div
            className="floating-card card-1 glass"
            animate={{ y: [0, -15, 0] }}
            transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
          >
            <span className="emoji">😴</span>
            <div>
              <h4>Better Sleep</h4>
              <p>Deep sleep sounds</p>
            </div>
          </motion.div>

          <motion.div
            className="floating-card card-2 glass"
            animate={{ y: [0, 15, 0] }}
            transition={{ repeat: Infinity, duration: 5, ease: "easeInOut" }}
          >
            <span className="emoji">🧘‍♀️</span>
            <div>
              <h4>Reduce Stress</h4>
              <p>Guided calm</p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
